// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l6MV8","footer":"styles_footer__2rF4l","passCodeTooltip":"styles_passCodeTooltip__3lEJC"};